module.exports = __webpack_public_path__ + "img/wallet_04_line.b9ebc560.png";